import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SeoContent from './components/SeoContent';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'SuperbuySpread',
  url: 'https://superbuyspread.store/',
  description: 'Master Superbuy Spreadsheet with expert guides, comparison tables, templates, workflow tips, and security recommendations. Independent educational resource updated for 2026.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://superbuyspread.store/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SuperbuySpread',
  url: 'https://superbuyspread.store/',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  description: 'The Ultimate Superbuy Spreadsheet Learning Platform - independent educational resource for spreadsheet-based shopping management.',
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Superbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Superbuy Spreadsheet is a structured organizational system for managing product research, price tracking, order details, and shopping workflows. It helps users keep all their shopping information organized in one accessible spreadsheet format, reducing confusion and improving efficiency.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Superbuy Spreadsheet free to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, you can create your own Superbuy Spreadsheet using free tools like Google Sheets or Microsoft Excel. Many community members share free templates that you can download and customize for your specific needs without any cost.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I create a Superbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Start with a blank spreadsheet and add columns for product name, URL, price, size, color, shipping cost, and order status. You can also download a pre-made Superbuy Spreadsheet template and customize it to match your workflow preferences.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Superbuy Spreadsheet safe to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, a Superbuy Spreadsheet itself is completely safe as it is simply an organizational tool. The safety depends on how you use it. Never store passwords or payment information in your spreadsheet, and always use trusted platforms for actual purchases.',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <SeoContent />
      </main>
      <Footer />
    </>
  );
}